export const CLEAR_STORE = "CLEAR_STORE";
export const SET_PAGE_LOADING = "SET_PAGE_LOADING";
export const SET_NAVBAR_TITLE = "SET_NAVBAR_TITLE";
export const SET_IS_DRAWER_OPEN = "SET_IS_DRAWER_OPEN";
